<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.86133 4.76562H21.1426C21.1426 4.76562 22.5488 4.76562 22.5488 6.17188V21.6406C22.5488 21.6406 22.5488 23.0469 21.1426 23.0469H2.86133C2.86133 23.0469 1.45508 23.0469 1.45508 21.6406V6.17188C1.45508 6.17188 1.45508 4.76562 2.86133 4.76562Z"
      stroke="#272727"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.45508 10.3906H22.5488"
      stroke="#272727"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.08008 6.875V1.95312"
      stroke="#272727"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.9238 6.875V1.95312"
      stroke="#272727"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
